/* eslint-disable react/destructuring-assignment */
import { Group } from '@mantine/core';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityTreatmentType } from '../../../../../../../models/core/entities.type';

type DataViewActionProps = {
  item: EntityTreatmentType;
  confirmActionResult(items: EntityTreatmentType[] | null, action: string, confirmed: boolean): void;
};

export default function TreatmentFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá o tratamento."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult([props.item], 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult([props.item], 'excluir', false);
        }}
      />
    </Group>
  );
}
